let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("h3DZN")).then(() => parcelRequire('4017U'));